import { EventEmitter, Injectable } from "@angular/core";
import { TokenService } from "./token.service";
import { firstValueFrom } from "rxjs";
import { LogService } from "../log/log.service";

declare const getTokenAndroid;

declare global {
  interface Window {
    tokenResponse: (token: any, error: string) => any;
    webkit: any;
  }
}

@Injectable({
  providedIn: "root",
})
export class TokenDeviceService implements TokenService {
  private EmmitChange = new EventEmitter<{ token; error }>();

  private readonly REL_ANDROID = "getTokenAndroid";
  private readonly REL_IOS = "getTokenIOS";
  private readonly GENERIC_ERROR_MESSAGE = "Erro generico obtendo token";
  private tokenTimeExp = 0;
  private token = "";
  private tokenTime = 0;

  constructor(private logService: LogService) {
    window.tokenResponse = (token: string, error: string) => {
      this.EmmitChange.emit({ token, error });
    };
  }

  private sendMessageDevice(): void {
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.getTokenIOS
    ) {
      this.comunicationIos(this.REL_IOS);
    } else {
      this.comunicationAndroid(this.REL_ANDROID);
    }
  }

  async getToken(): Promise<string> {
    try {
      if (
        this.token &&
        this.tokenTime + this.tokenTimeExp < new Date().getTime()
      ) {
        return Promise.resolve(this.token);
      } else {
        this.sendMessageDevice();

        const tokenResponse = await firstValueFrom(this.EmmitChange);

        this.logService.save(
          JSON.stringify(tokenResponse),
          "TokenDeviceService.getToken"
        );

        if (tokenResponse.token) {
          let token = tokenResponse.token;
          while (typeof token != "string" && token != undefined) {
            token = token.token;
          }

          this.token = token;
          return new Promise<string>((resolve, reject) => {
            resolve(this.token);
          });
        } else if (tokenResponse.error) {
          return new Promise<string>((resolve, reject) => {
            reject(tokenResponse.error);
          });
        } else {
          return new Promise<string>((resolve, reject) => {
            reject(this.GENERIC_ERROR_MESSAGE);
          });
        }
      }
    } catch (err) {
      return Promise.reject(new Error(err));
    }
  }

  private comunicationIos(rel: any) {
    window.webkit.messageHandlers.getTokenIOS.postMessage({
      rel,
    });
  }

  private comunicationAndroid(rel: string) {
    getTokenAndroid.postMessage(rel);
  }
}
